import type { SVGProps } from 'react'
const UseriDocumentIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 210 210"
    {...props}
  >
    <g filter="url(#Useri_Document_svg__a)">
      <rect
        width={144}
        height={144}
        x={33.001}
        y={23.6}
        fill="#fff"
        rx={30.29}
      />
      <path
        fill="#C8D3F7"
        d="M74.278 98.44c.924-14.099 1.386-21.148 6.053-25.241s11.717-3.631 25.816-2.707l14.954.98c14.099.924 21.149 1.387 25.242 6.054s3.631 11.716 2.707 25.815-1.386 21.149-6.054 25.242c-4.667 4.093-11.716 3.631-25.815 2.707l-14.955-.98c-14.099-.925-21.148-1.387-25.241-6.054s-3.631-11.716-2.707-25.815"
      />
      <path
        fill="#2852E4"
        d="M58.422 99.713c-2.156-13.964-3.234-20.946.434-25.953 3.669-5.008 10.65-6.086 24.615-8.242l14.81-2.286c13.965-2.156 20.947-3.233 25.954.435s6.086 10.65 8.242 24.614c2.155 13.964 3.233 20.946-.435 25.954s-10.651 6.085-24.615 8.241l-14.81 2.286c-13.965 2.156-20.946 3.234-25.954-.434s-6.086-10.651-8.241-24.615"
      />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth={3.125}
        d="m117.875 86.832-13.011 1.999M116.366 77.104l-16.264 2.5M119.383 96.56l-9.759 1.499"
      />
      <ellipse
        cx={6.085}
        cy={6.067}
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth={3.125}
        rx={6.085}
        ry={6.067}
        transform="rotate(-8.736 572.855 -452.666)skewX(.079)"
      />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth={3.125}
        d="M97.163 102.969c.514 3.311.93 5.996-11.098 7.844s-12.445-.836-12.958-4.147c-.514-3.311 4.455-6.823 11.098-7.844s12.445.836 12.958 4.147Z"
      />
    </g>
    <defs>
      <filter
        id="Useri_Document_svg__a"
        width={209.028}
        height={209.028}
        x={0.487}
        y={0.461}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={9.375} />
        <feGaussianBlur stdDeviation={16.257} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1_7351" />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1_7351"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)
export default UseriDocumentIcon
